import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

// import Wave from "../../../Assets/Img/wave.png";
import Navbar from "../../Atoms/Navbar";
// import PersonalInfoimg from "../../../Assets/Img/personalinfoimg.png";
// import Documentimg from "../../../Assets/Img/documentimg.png";
// import Employmentimg from "../../../Assets/Img/employmentimg.png";
import Questions from '../../Atoms/Question';
import './style.css'
import analytics from '../../../firebase.config';

import { getAnalytics, logEvent } from "firebase/analytics";
const Dashboard = () => {
  const history = useNavigate();
  const [resumeFormStatus, setResumeFormStatus] = useState();
  const [notificationData, setNotificationData] = useState([]);
  var editFormStatus = localStorage.getItem("editFormStatus")
  useEffect(() => {


    let resumeBtn = localStorage.getItem("save&exist");


    setResumeFormStatus(resumeBtn)


  }, []);
  const PersonalInformationModel = () => {
    // Get the modal
    var modal = document.getElementById("PersonalInformationModal");

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("close");
    // When the user clicks the button, open the modal
    modal.style.display = "block";

    // When the user clicks on <span> (x) or Close, close the modal

    for (let i = 0; i < span.length; i++) {
      console.log(span, span[i]);
      span[i].onclick = function () {
        modal.style.display = "none";
      };
    }
    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
        logEvent(analytics, 'dashb_pop_up_press_background');

      }
    };
  };

  const openTradingAccount = async () => {
    if (resumeFormStatus == 'true') {
      logEvent(analytics, 'dashb_resume_opening_trading_account');
    }
    else {
      logEvent(analytics, 'dashb_press_open_trading_account_btn');
    }



    await PersonalInformationModel()
  }

  const handleContinueBtn = () => {

    logEvent(analytics, 'dashb_press_open_trading_account_btn');
    history("/AOF");

  }
  const handleWhatsapp = () => {
    window.open('https://api.whatsapp.com/send/?phone=923146398227&text&app_absent=0', '_blank').focus();
  }
  const EmploymentDetailsModel = () => {
    // Get the modal
    var modal = document.getElementById("EmploymentDetailsModal");

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("close");
    // When the user clicks the button, open the modal
    modal.style.display = "block";

    // When the user clicks on <span> (x) or Close, close the modal

    for (let i = 0; i < span.length; i++) {
      console.log(span, span[i]);
      span[i].onclick = function () {
        modal.style.display = "none";
      };
    }
    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    };
  };

  const DocumentsAttachmentModel = () => {
    // Get the modal
    var modal = document.getElementById("DocumentsAttachmentModal");

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("close");
    // When the user clicks the button, open the modal
    modal.style.display = "block";

    // When the user clicks on <span> (x) or Close, close the modal

    for (let i = 0; i < span.length; i++) {
      console.log(span, span[i]);
      span[i].onclick = function () {
        modal.style.display = "none";
      };
    }
    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    };
  };

  return (
    <>
      <Navbar />

      <div className="bg-color">
        <div className="container pt-3">
          <div className="row">
            <div className="col-md-7">
              <div className="bg-white mt-3 shadow edge-welcome p-4">
                <h2>Welcome</h2>
                <p className="text-gray welcome-text">
                  Submit your trading account application in 5 minutes and join a quarter of a million people already investing in the Pakistan Stock Exchange
                </p>

                <button
                  className="NavButton primary-btn"
                  onClick={() => openTradingAccount()}
                  disabled={editFormStatus == "true" ? true : false}
                >

                  {resumeFormStatus == "true" ? "Resume Trading Account" : "Open trading account"}
                </button>
              </div>
              <div className="bg-white d-none d-md-block">
                {/* <img src={Wave} className="w-100" /> */}
                <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/wave.png" alt="wave" className="w-100" />
              </div>
            </div>
            <div className="col-md-4  mt-3">



              {/* <button
                  className="NavButton primary-btn"
                  onClick={() => openTradingAccount()}
                >

                  {resumeFormStatus == "true" ? "Resume Trading Account" : "Open trading account"}
                </button> */}

              <Questions />
              {/* <div className="bg-Pink edge px-5 px-md-3 py-3">
                <h3 className="me-auto text-white fs16 fw-800">Questions?</h3>
                <p className="heading">
                  Don't hesitate to contact our support team on the following
                  numbers.
                </p>
                <div className="d-flex d-sm-flex d-md-block d-lg-flex"> 
                  <p
                    className="text-white fs-small fw-800"  
                    
                  >
                    UAN
                  </p>
                  <p className="ms-auto text-white fs-small fw-bold">
                  021 111 639 825 Ext 147
                  </p>
                </div>
                <div className="d-flex d-sm-flex d-md-block d-lg-flex">
                  <p
                    className="text-white fs-small fw-800"
                  
                  >
                    WhatsApp
                  </p>
                  <p className="ms-auto text-white fs-small fw-bold " >
                 <a className="text-white" onClick={() => handleWhatsapp()}>+92 314 NEXTCAP (6398227)</a> 
                  </p>
                </div>
                <div className="d-flex d-sm-flex d-md-block d-lg-flex">
                  <p
                    className="text-white fs-small fw-800"
                   
                  >
                    Email
                  </p>
                  <p className="ms-auto text-white fs14 fw-800">
                    cs@nextcapital.com.pk
                  </p>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div className="modal" tabIndex="-1" role="dialog" id="myModal">
        <div className="modal-dialog centerr p-0" role="document">
          <div className="modal-content">
            <div className="modal-header p-0">
              <h5 className="modal-title t-pink">Information Submited</h5>

              <span className="close cross">&times;</span>
            </div>
            <div className="modal-body px-0">

              <p className="fw-500 fs16 ms-auto t-grey-400 cursorPointer">
                Thank You For Submiting Your From
              </p>
            </div>
            <div className="modal-footer px-0">
              <NavLink to="/Otp">
                <button
                  type="button"
                  className="btn-outlined fs16 px-3 py-2 mx-2 close"
                  data-dismiss="modal"
                >
                  OK
                </button>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal pop-up"
        tabIndex="-1"
        role="dialog"
        id="PersonalInformationModal"
      // style={{backgroundColor:"grey"}}
      >
        <div className="modal-dialog centerr p-0" role="document">
          <div className="modal-content">
            <div className="modal-body text-center p-2 ">
              {/* <img src={PersonalInfoimg} /> */}
              <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/personalinfoimg.png" alt="personalinfoimg" />
            </div>
            <div className="modal-body text-center p-2 ">

              <p className="t-grey-800 fw-800 ls4 fs32">What we’ll need</p>
              <p className="fw-lighter t-grey-200 fs16">
                Regulatory authorities require us to collect personal, income and employment information to open a trading account. This ensures a robust and fair trading experience for all investors.<br />
              </p>
              <p className="fw-lighter t-grey-200 fs16">Please also keep your CNIC ready as you’ll need to submit pictures of it.
              </p>
              {/* <div className="d-inline-flex">
                <p className='mdl-step active mx-2 text-center'></p>
                <p className='mdl-step mx-2 text-center'></p>
                <p className='mdl-step mx-2 text-center'></p>
              </div> */}
              {/* <button
                className="my-3 py-3 edge w-100 NavButton btn border-0 close"
                onClick={() => EmploymentDetailsModel()}
              >
                Continue
              </button> */}
              {/* <NavLink to="/AOF"> */}
              <button className="my-3 py-3 edge w-100 NavButton btn  border-0"

                onClick={() => handleContinueBtn()}
              >

                Continue
              </button>
              {/* </NavLink> */}
            </div>
          </div>
        </div>
      </div>
      {/* <div
        className="modal pop-up"
        tabIndex="-1"
        role="dialog"
        id="EmploymentDetailsModal"
      >
        <div className="modal-dialog centerr p-0" role="document">
          <div className="modal-content">
            <div className="modal-body text-center my-3 ">
              <img src={Employmentimg} />
            </div>
            <div className="modal-body text-center mb-3 ">

              <p className="t-grey-800 fw-800 ls4 fs32">Employment Details</p>
              <p className="fw-lighter t-grey-200 fs16">
                NCCPL and SECP requires you to provide your employment
                information sch as employment details and employment address and
                other valuable details.
              </p>
              <div className="d-inline-flex">
                <p className='mdl-step mx-2 text-center'></p>
                <p className='mdl-step active mx-2 text-center'></p>
                <p className='mdl-step mx-2 text-center'></p>
              </div>
              <button
                className="my-3 py-3 edge w-100 NavButton btn border-0 close"
                onClick={() => DocumentsAttachmentModel()}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal pop-up"
        tabIndex="-1"
        role="dialog"
        id="DocumentsAttachmentModal"
      >
        <div className="modal-dialog centerr p-0" role="document">
          <div className="modal-content">
            <div className="modal-body text-center my-3 ">
              <img src={Documentimg} />
            </div>
            <div className="modal-body text-center mb-3 ">

              <p className="t-grey-800 fw-800 ls4 fs32">Doccument Attachments</p>
              <p className="fw-lighter t-grey-200 fs16">
                Keep your documents in handy. You'll need to submit them as a
                source of verification of your identity, employment and proof of
                income.
              </p>
              <div className="d-inline-flex">
                <p className='mdl-step mx-2 text-center'></p>
                <p className='mdl-step mx-2 text-center'></p>
                <p className='mdl-step active mx-2 text-center'></p>
              </div>
              <NavLink to="/AOF">
                <button className="my-3 py-3 edge w-100 NavButton btn  border-0">

                  Continue
                </button>
              </NavLink>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default Dashboard;


